import { API_URL } from '@lib/constants/environment';
import { ISearchResults } from '@types';
import { handleError } from '@utils/error-handling';

export async function getSearchApi(query: string, signal: AbortSignal): Promise<{ results: ISearchResults }> {
  const res = await fetch(`${API_URL}/catalog/search?instock=0&s=${query}`, { signal });
  return handleError<{ results: ISearchResults }>(res);
}
